<template>
	<div class="container mx-auto max-w-5xl px-4">
		<div class="flex overflow-hidden p-2">
			<HelpfulTips>
				Our offers do not change if you decide to sell or trade your car. We’ll buy your car
				even if you do not buy ours.
			</HelpfulTips>

			<div class="grow basis-1/2 overflow-y-auto">
				<div
					v-for="sellType in sellTypes"
					:key="sellType.id"
					class="box-border flex cursor-pointer flex-col py-2 pl-4 lg:pr-6"
					@click="handleWantClick(sellType)"
				>
					<div class="text-main-400 flex select-none items-center text-xl font-bold">
						<AppCheckbox
							class="text-success-base xs:mr-3 mr-2"
							:checked="form.sellType === sellType.type"
						/>

						{{ sellType.name }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { useFormStore } from '../../../stores/form'
	import HelpfulTips from '../components/HelpfulTips.vue'
	import AppCheckbox from '../../common/AppCheckbox.vue'

	const form = useFormStore()

	const handleWantClick = (w: { id: number; name: string; type: string; comment?: string }) => {
		form.sellType = w.type
	}

	const sellTypes = [
		{
			id: 0,
			name: 'I want to sell',
			type: 'SELL',
		},
		{
			id: 1,
			name: 'I want to trade in',
			comment: '',
			type: 'TRADE',
		},
		{
			id: 2,
			name: 'Not sure',
			type: 'NOT_SURE',
		},
	]
</script>
